/* src/app/admin-dashboard/site-system/extra-inventory/extrastockcontroll/extrastockcontroll.component.css */
mat-grid-tile {
  background: lightblue;
}
.col {
  margin: 2px;
  height: 100px;
  color: grey;
  cursor: pointer;
}
.col:hover {
  color: black;
  height: 99px;
  border: 2px solid #563d7c;
  border-radius: 5px;
}
.mat-mdc-tooltip {
  color: yellow !important;
}
a {
  margin: 5px;
  color: black;
}
.active {
  background: #8468ac;
}
.header img {
  float: left;
  width: 100px;
  height: 100px;
  background: #555;
}
.header h4 p {
  position: relative;
  top: 18px;
  left: 10px;
}
.belowThreashold {
  background: #FF9494;
}
.framentLoaded {
  background: white;
  animation: color-me-in 5s;
}
@media screen and (max-width: 768px) {
  .mat-mdc-table .mat-mdc-row {
    height: 44px !important;
  }
  .mat-mdc-cell {
    font-size: 13px;
    color: #2a3547;
    padding: 0 4px !important;
  }
  app-action-button-toolbar mat-icon {
    font-size: 28px !important;
    width: 28px !important;
    height: 28px !important;
    margin: 0 2px;
    color: #5d87ff;
  }
}
@keyframes color-me-in {
  0% {
    background: var(--custom-color);
  }
  100% {
    background: white;
  }
}
/*# sourceMappingURL=extrastockcontroll.component.css.map */
